export async function fetchText(url: string): Promise<string> {
  const res = await fetch(url, { credentials: 'omit' })
  if (!res.ok) throw new Error(`Failed to fetch spec: ${res.status} ${res.statusText}`)
  return res.text()
}

export async function parseSpec(text: string): Promise<any> {
  try {
    return JSON.parse(text)
  } catch (_) {
    const yaml = await import('js-yaml')
    return yaml.load(text)
  }
}
